import SaleSignV2 from './SaleSignV2';
import IconPiggyBank from './IconPiggyBank';
import IconZOHome from './IconZOHome';
import HouseWithDollarSign from './HouseWithDollarSign';
import HangingSign from './HangingSign';
import HangingSignV2 from './HangingSignV2';
import TestimonialIcon from './TestimonalIcon';
import HourglassIcon from './HourglassIcon';
import MoneyIcon from './MoneyIcon';
import RightHome from './RightHome';
import GettingStarted from './GettingStarted';
import NeighborhoodHelp from './NeighborhoodHelp';
import HeartHome from './HeartHome';
import AppHome from './AppHome';
import ComparableHome from './ComparableHome';
import Calendar from './Calendar';
import IconAwardCheck from './IconAwardCheck';
import IconAwardStar from './IconAwardStar';
export default {
  saleSign: SaleSignV2,
  piggy: IconPiggyBank,
  ZOHome: IconZOHome,
  houseWithDollarSign: HouseWithDollarSign,
  hangingSign: HangingSign,
  hangingSignV2: HangingSignV2,
  testimonialIcon: TestimonialIcon,
  hourglassIcon: HourglassIcon,
  moneyIcon: MoneyIcon,
  rightHome: RightHome,
  gettingStarted: GettingStarted,
  neighborhoodHelp: NeighborhoodHelp,
  heartHome: HeartHome,
  appHome: AppHome,
  comparableHome: ComparableHome,
  calendar: Calendar,
  awardCheck: IconAwardCheck,
  awardStar: IconAwardStar
};